import { createRouter, createWebHistory } from 'vue-router'
import MainLayout from "@/layouts/MainLayout.vue";
import LoginPage from "@/views/LoginPage.vue";
import AuthLayout from "@/layouts/AuthLayout.vue";
import ErrorPage from "@/views/ErrorPage.vue";
import MaterialPage from "@/views/materials/MaterialPage.vue";
import TestPage from "@/views/test/TestPage.vue";
import TagsPage from "@/views/TagsPage.vue";
import CreateMaterialPage from "@/views/materials/CreateMaterialPage.vue";
import UpdateMaterialPage from "@/views/materials/UpdateMaterialPage.vue";
import {DEFAULT_LOGIN_URL, DEFAULT_ROLE_URL, handleAuthMiddleware} from "@/middleware/auth";
import store from "@/store";
import ServicesPage from "@/views/services/ServicesPage.vue";
import AcademyPage from "@/views/academy/AcademyPage.vue";
import CreateAcademyPage from "@/views/academy/CreateAcademyPage.vue";
import UpdateAcademyPage from "@/views/academy/UpdateAcademyPage.vue";
import PartnershipPage from "@/views/partnership/PartnershipPage.vue";
import PartnersPage from "@/views/partners/PartnersPage.vue";
import CreatePartnerPage from "@/views/partners/CreatePartnerPage.vue";
import EditPartnerPage from "@/views/partners/EditPartnerPage.vue";
import ClientLogosPage from "@/views/client-logos/ClientLogosPage.vue";
import CreateClientLogoPage from "@/views/client-logos/CreateClientLogoPage.vue";
import EditClientLogoPage from "@/views/client-logos/EditClientLogoPage.vue";
import ServiceForm from "@/views/services/ServiceForm.vue";

const routes = [
  {
    path: '/',
    name: 'home',
    component: MainLayout,
    children: [
      {
        path: '/dev-test',
        name: 'dev-test',
        component: TestPage
      },
      {
        path: '/',
        name: 'login',
        component: LoginPage
      },
      {
        path: '/',
        name: 'auth-layout',
        component: AuthLayout,
        meta: { auth: true },
        children: [
          {
            path: '/error',
            name: 'error',
            component: ErrorPage
          },
          {

            path: '/services',
            name: 'services',
            component: ServicesPage
          },
          {

            path: '/services-create',
            name: 'services-create',
            component: ServiceForm
          },
          {
            path: '/services-edit/:id',
            name: 'services-edit',
            component: ServiceForm
          },
          {

            path: '/material',
            name: 'material',
            component: MaterialPage
          },
          {

            path: '/material-create',
            name: 'material-create',
            component: CreateMaterialPage
          },
          {

            path: '/material-edit/:id',
            name: 'material-edit',
            props: true,
            component: UpdateMaterialPage
          },
          {

            path: '/academy',
            name: 'academy',
            component: AcademyPage
          },
          {

            path: '/academy-create',
            name: 'academy-create',
            component: CreateAcademyPage
          },
          {

            path: '/academy-edit/:id',
            name: 'academy-edit',
            props: true,
            component: UpdateAcademyPage
          },
          {

            path: '/tags',
            name: 'tags',
            component: TagsPage
          },
          {

            path: '/partnership',
            name: 'partnership',
            component: PartnershipPage
          },
          {

            path: '/partners',
            name: 'partners',
            component: PartnersPage
          },
          {
            path: '/partners-create',
            name: 'partners-create',
            component: CreatePartnerPage
          },
          {
            path: '/partners/edit/:id',
            name: 'partners-edit',
            component: EditPartnerPage
          },
          {
            path: '/client-logos',
            name: 'client-logos',
            component: ClientLogosPage
          },
          {
            path: '/client-logos-create',
            name: 'client-logos-create',
            component: CreateClientLogoPage
          },
          {
            path: '/client-logos/edit/:id',
            name: 'client-logos-edit',
            component: EditClientLogoPage
          }
        ]
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from, next) => {
  await handleAuthMiddleware();
  let me = store.state.user.me;
  if(me && to.meta?.auth === true) {
    return next()
  } else if(!me && to.meta?.auth === true) {
    return next('/')
  } else if(me && to.path === '/') {
    return next('/services')
  } else {
    return next()
  }
});

export default router
